module.exports = __webpack_public_path__ + "img/logo.f70115d1.png";